import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { CalendarIcon, ClipboardListIcon, RepeatIcon, SettingsIcon, LogOutIcon, MenuIcon, XIcon } from 'lucide-react';
const Navbar = () => {
  const {
    user,
    logout
  } = useUser();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  if (!user) return null;
  const handleLogout = () => {
    logout();
    navigate('/login');
    setIsMobileMenuOpen(false);
  };
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };
  return <nav className="text-white shadow-md" style={{
    backgroundColor: '#4772B0'
  }} data-id="element-366">
      <div className="container mx-auto px-4" data-id="element-367">
        <div className="flex justify-between items-center py-4" data-id="element-368">
          <Link to="/" className="flex items-center space-x-3" onClick={closeMobileMenu} data-id="element-369">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pqFwhPa2herr53Qjo4Lf86/image.png" alt="RowDate.com" className="h-10 w-auto" data-id="element-370" />
          </Link>
          <div className="hidden md:flex space-x-6" data-id="element-371">
            <Link to="/" className="flex items-center hover:text-gray-200 transition-colors" data-id="element-372">
              <CalendarIcon className="mr-1" size={18} data-id="element-373" /> Dashboard
            </Link>
            <Link to="/calendar" className="flex items-center hover:text-gray-200 transition-colors" data-id="element-374">
              <CalendarIcon className="mr-1" size={18} data-id="element-375" /> Calendar
            </Link>
            <Link to="/request-shifts" className="flex items-center hover:text-gray-200 transition-colors" data-id="element-376">
              <ClipboardListIcon className="mr-1" size={18} data-id="element-377" /> Request Shifts
            </Link>
            <Link to="/trade-shifts" className="flex items-center hover:text-gray-200 transition-colors" data-id="element-378">
              <RepeatIcon className="mr-1" size={18} data-id="element-379" /> Trade Shifts
            </Link>
            {user.isAdmin && <Link to="/admin" className="flex items-center hover:text-gray-200 transition-colors" data-id="element-380">
                <SettingsIcon className="mr-1" size={18} data-id="element-381" /> Admin Settings
              </Link>}
          </div>
          <div className="flex items-center space-x-4" data-id="element-382">
            <span className="hidden md:inline" data-id="element-383">{user.name}</span>
            <button onClick={handleLogout} className="hidden md:flex items-center hover:text-gray-200 transition-colors" data-id="element-384">
              <LogOutIcon size={18} className="mr-1" data-id="element-385" /> Logout
            </button>
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2 rounded transition-colors" style={{
            backgroundColor: isMobileMenuOpen ? '#EF5350' : 'transparent'
          }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#EF5350'} onMouseLeave={e => e.currentTarget.style.backgroundColor = isMobileMenuOpen ? '#EF5350' : 'transparent'} data-id="element-386">
              {isMobileMenuOpen ? <XIcon size={24} data-id="element-387" /> : <MenuIcon size={24} data-id="element-388" />}
            </button>
          </div>
        </div>
        {isMobileMenuOpen && <div className="md:hidden pb-4 space-y-2" data-id="element-389">
            <Link to="/" className="flex items-center py-2 px-4 rounded transition-colors hover:bg-opacity-80" style={{
          backgroundColor: 'transparent'
        }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#EF5350'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'} onClick={closeMobileMenu} data-id="element-390">
              <CalendarIcon className="mr-2" size={18} data-id="element-391" /> Dashboard
            </Link>
            <Link to="/calendar" className="flex items-center py-2 px-4 rounded transition-colors" style={{
          backgroundColor: 'transparent'
        }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#EF5350'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'} onClick={closeMobileMenu} data-id="element-392">
              <CalendarIcon className="mr-2" size={18} data-id="element-393" /> Calendar
            </Link>
            <Link to="/request-shifts" className="flex items-center py-2 px-4 rounded transition-colors" style={{
          backgroundColor: 'transparent'
        }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#EF5350'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'} onClick={closeMobileMenu} data-id="element-394">
              <ClipboardListIcon className="mr-2" size={18} data-id="element-395" /> Request Shifts
            </Link>
            <Link to="/trade-shifts" className="flex items-center py-2 px-4 rounded transition-colors" style={{
          backgroundColor: 'transparent'
        }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#EF5350'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'} onClick={closeMobileMenu} data-id="element-396">
              <RepeatIcon className="mr-2" size={18} data-id="element-397" /> Trade Shifts
            </Link>
            {user.isAdmin && <Link to="/admin" className="flex items-center py-2 px-4 rounded transition-colors" style={{
          backgroundColor: 'transparent'
        }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#EF5350'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'} onClick={closeMobileMenu} data-id="element-398">
                <SettingsIcon className="mr-2" size={18} data-id="element-399" /> Admin Settings
              </Link>}
            <div className="border-t border-blue-600 pt-2 mt-2" data-id="element-400">
              <div className="px-4 py-2 text-sm" data-id="element-401">{user.name}</div>
              <button onClick={handleLogout} className="flex items-center w-full py-2 px-4 rounded transition-colors" style={{
            backgroundColor: 'transparent'
          }} onMouseEnter={e => e.currentTarget.style.backgroundColor = '#EF5350'} onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'} data-id="element-402">
                <LogOutIcon size={18} className="mr-2" data-id="element-403" /> Logout
              </button>
            </div>
          </div>}
      </div>
    </nav>;
};
export default Navbar;